window.addEventListener('load', function() {
  // Get all elements with class 'h6' and 'group'
  const elements = document.querySelectorAll('#header-sidebar-menu a.h6.group[href="/pages/join-the-sunnyday-club"] > span > span');

  // Loop through each element and update its content and href attribute
  elements.forEach(element => {
    element.innerHTML = 'Join the <em>Sunnyday Club</em>';
  });
});

//update cart count (visible on header count) when ReBuy updates
document.addEventListener('rebuy:cart.change', (event) => {
  const cartCount = event.detail.cart.cart.item_count;
  const cartCountEl = document.querySelector('cart-count');

  cartCountEl.innerHTML = cartCount;

  if (cartCount == 0) {
    cartCountEl.style.opacity = 0;
  } else {
    cartCountEl.style.opacity = 1;
  }
});
$(document).ready(function() {
  $(".product-card-variant input").attr("disabled", "true");
});
const reChargeDebug = false;

$(document).ready(function() {
  var checkExist = setInterval(function() {
    if ($('.rc-widget').length) {
      if (reChargeDebug) console.log("TEST .rc-widget exists!");

      // -------------
      // matcha whisk
      // -------------
      if (window.location.href.includes("matcha")) {
        const targetEl = document.querySelector(".rc-subscription-details__button span:last-child");
        targetEl.innerHTML = "As a member of the club you’ll get a FREE matcha whisk and unlock...";
      }

      // -------------
      // 3 weeks
      // -------------
      $(".rc-selling-plans-dropdown__select option:contains('3 Weeks')").prop('selected', true);
      $(".rc-selling-plans-dropdown__select").trigger('change');
      const planId = $(".rc-selling-plans-dropdown__select option:contains('3 Weeks')").prop('value');
      $("input[name='selling_plan']").prop("value", planId);
      const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?selling_plan=' + planId; //should be 689339695421

      window.history.pushState({path: newUrl}, '', newUrl);

      clearInterval(checkExist);
    }
  }, 200);

  // Stop checking after 10 seconds
  setTimeout(function() {
      clearInterval(checkExist);
  }, 10000);
});